import { worcesterConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function WorcesterPage() {
  return <CityPageTemplate config={worcesterConfig} />;
}